import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import TabsPage from '../views/TabsPage.vue'
import {ensureAuthenticated, ensureNotAuthenticated} from "@/router/guards";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginPage.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/RegisterPage.vue'),
    beforeEnter: [ensureNotAuthenticated],
  },
  {
    path: '/no-connection',
    name: 'no-connection',
    component: () => import('@/views/NoConnectionPage.vue'),
  },
  {
    path: '/verify-email',
    name: 'verify-email',
    component: () => import('@/views/VerifyEmailPage.vue'),
  },
  {
    path: '/tabs/',
    component: TabsPage,
    beforeEnter: [ensureAuthenticated],
    children: [
      {
        path: '',
        redirect: '/tabs/home',
      },
      {
        path: 'home',
        component: () => import('@/views/HomeFeedPage.vue'),
      },
      {
        path: 'tab3',
        component: () => import('@/views/Tab3Page.vue'),
      },
      {
        path: 'garden',
        component: () => import('@/views/GardenPage.vue'),
      },
      {
        path: 'marketplace',
        name: 'marketplace',
        component: () => import('@/views/marketplace/MarketplacePage.vue'),
      },
      {
        path: 'inbox',
        name: 'inbox',
        component: () => import('@/views/InboxPage.vue'),
      },
      {
        path: 'inbox/:conversationId',
        name: 'conversation',
        component: () => import('@/views/ConversationPage.vue'),
      },
      {
        path: 'marketplace/new',
        name: 'marketplace-new',
        component: () => import('@/views/marketplace/CreateListingPage.vue'),
      },
      {
        path: 'marketplace/mine',
        name: 'marketplace-mine',
        component: () => import('@/views/marketplace/MyListingsPage.vue'),
      },
      {
        path: 'marketplace/:id/edit',
        name: 'marketplace-edit',
        component: () => import('@/views/marketplace/EditListingPage.vue'),
      },
      {
        path: 'plots',
        name: 'plot-index',
        component: () => import('@/views/PlotIndexPage.vue'),
      },
      {
        path: 'plots/:plotSlug',
        name: 'plot-profile',
        component: () => import('@/views/PlotProfilePage.vue'),
      },
      {
        path: 'settings',
        component: () => import('@/views/SettingsPage.vue'),
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
